import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "carousel" }
const _hoisted_2 = { class: "track" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (src, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "slide",
          key: `img-${index}`
        }, [
          _createElementVNode("img", {
            src: src,
            alt: "foto"
          }, null, 8, _hoisted_3)
        ]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (src, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "slide",
          key: `dup-${index}`
        }, [
          _createElementVNode("img", {
            src: src,
            alt: "foto"
          }, null, 8, _hoisted_4)
        ]))
      }), 128))
    ])
  ]))
}